import { Injectable } from '@angular/core';
import { IncidentServiceBase } from '../services/incident-base.service';
import { JudgmentIncidentModel } from '../models/judgment-incident.model';

@Injectable()
export class JudgmentIncidentService extends IncidentServiceBase<JudgmentIncidentModel> {
    constructor() {
        super('JudgmentIncident', () => new JudgmentIncidentModel());
    }
}
